export default __webpack_public_path__ + "clouds.png?d60d31c0b9244f495ad9cc4dcd1e8de6";